import { Phone, MessageSquare } from "lucide-react";
import { COMPANY } from "@/lib/api";
import { onCallClick, onTextClick } from "@/lib/dialer";

export default function FloatingCTA() {
  return (
    <div className="fixed bottom-4 inset-x-0 z-40 md:hidden px-4 pointer-events-none">
      <div className="grid grid-cols-2 gap-3 pointer-events-auto">
        <a href={`tel:${COMPANY.phoneTel}`} onClick={onCallClick} data-testid="float-call"
           className="btn-primary py-3.5 rounded-full text-sm font-semibold flex items-center justify-center gap-2 shadow-ice-glow animate-pulse-soft">
          <Phone className="size-4" /> Call Now
        </a>
        <a href={COMPANY.sms} onClick={onTextClick} data-testid="float-text"
           className="btn-ghost glass py-3.5 rounded-full text-sm font-semibold flex items-center justify-center gap-2">
          <MessageSquare className="size-4" /> Text Us
        </a>
      </div>
    </div>
  );
}
